import React from 'react';
import NewTransactionForm from '../Components/NewTransactionForm.js';

function New() {
    return (
        <div>
            <NewTransactionForm />
        </div>
    );
};

export default New;